var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('h1',[_vm._v("Call us at "),_c('a',{attrs:{"href":("tel:+1" + _vm.phone)}},[_vm._v(_vm._s(_vm._f("phoneNumber")(_vm.phone)))]),_vm._v(" to claim this offer.")])])}
var staticRenderFns = []

export { render, staticRenderFns }